function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "loan-contact-arrow");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.16,
    height: 9.35,
    viewBox: "0 0 14.16 9.35"
  }, props), _ref, /*#__PURE__*/React.createElement("polygon", {
    points: "7.1 9.35 0 0 14.16 0 7.1 9.35",
    style: {
      "fill": "#fff"
    }
  }));
};

export default __webpack_public_path__ + "static/media/loan-contact-arrow.8d5cc3cb.svg";
export { SvgComponent as ReactComponent };